import { createStore } from "vuex";

import notes from './modules/notes';
import users from './modules/users';
import chats from './modules/chats';

export default createStore({
  modules: {
    notes,
    users,
    chats,
  }
});
